/**
 * Screen readers pause on a comma but read `·` out loud (or skip it) depending on the reader and
 * its verbosity setting, so accessible names of matrix cells join their parts with a comma. The
 * `·` stays where it belongs — in the visible tooltip text, which no assistive technology
 * announces.
 */
export const ACCESSIBLE_NAME_SEPARATOR = ', ';
